import { styled } from '@engyalo/design-system';
import { css, Stack } from '@mui/material';

export const CustomerInfoWrapper = styled(Stack)(
  () => css`
    flex-direction: row;
    align-items: center;
    gap: 0.8rem;
    overflow: hidden;
    flex: 1;
  `
);
